import React from 'react';

// import * as S from './BookingCardInfoHead.styles';
import HotelCardInfoHead from './HotelCardInfoHead';

const BookingCardInfoHead = ({data, navigateToMyTripsDetails}) => {
  const {vertical} = data;

  switch (vertical.toLowerCase()) {
    case 'hotels':
      return <HotelCardInfoHead data={data} navigateToMyTripsDetails={navigateToMyTripsDetails} />;
    default:
      return null;
  }
}

export default BookingCardInfoHead;